import {Component, Inject, OnInit} from '@angular/core';
import {UserService} from '../../shared/user.service';
import {downgradeComponent} from '@angular/upgrade/static';
import * as angular from 'angular';
import {ApiService} from '../../api/api.service';
import * as moment from 'moment';
import {
	GLOBAL_NOTIFICATION_TYPE,
	GlobalNotificationsService
} from '../../core/components/global-notifications/global-notifications.service';
import {CookieService} from 'ngx-cookie';
import {Moment} from 'moment';
@Component({
	selector: 'tt-personal-daily-report',
	templateUrl: 'personal-daily-report.component.html',
	styleUrls: ['personal-daily-report.component.scss']
})

export class PersonalDailyReportComponent implements OnInit {

	public processing: boolean = false;
	constructor(
		private userService: UserService,
		private apiService: ApiService,
		private gns: GlobalNotificationsService,
		private cookieService: CookieService
	) {

	}

	ngOnInit(): void {
		this.processing = false;
	}

	public sendReport(): void {
		this.processing = false;
		const selectedDate: Moment = (this.cookieService.get('selectedDate')) ? moment(this.cookieService.get('selectedDate')) : moment();
		this.apiService.sendEmployeeDailyReport(selectedDate.format('YYYY-MM-DD'), this.userService.user.id)
			.subscribe((res: any) => {
				if (res.success) {
					this.gns.sendNotification(GLOBAL_NOTIFICATION_TYPE.SUCCESS, 'Report submitted', 10000);
				} else {
					this.gns.sendNotification(GLOBAL_NOTIFICATION_TYPE.ERROR, 'Report is not submitted. Please, reload the page and try again', 10000);
				}
				this.processing = false;
			}, () => {
				this.gns.sendNotification(GLOBAL_NOTIFICATION_TYPE.ERROR, 'Report is not submitted. Please, reload the page and try again', 10000);
				this.processing = false;
			});
	}
}

angular.module('timetracker2')
	.directive(
		'ttPersonalDailyReport',
		downgradeComponent({ component: PersonalDailyReportComponent }) as angular.IDirectiveFactory
	);



// WEBPACK FOOTER //
// ./src/app/my-time/personal-daily-report/personal-daily-report.component.ts